import { config } from "../../../../enviroment";
import { apolloClientService } from "../../../../services/apollo-client";

export const calPowerValuesService = {
    calPowerValues,
};

function calPowerValues(customerNumber,startDate,endDate){
  const APIquery = `query{  getMonthlyCalPowerValues(input: {customerNumber: "`+customerNumber+`",startdate:"`+startDate+`",enddate:"`+endDate+`"}) {    statusCode    statusMessage1    statusMessage2    statusMessage3    statusMessage4    maxDemand    powerFactor    loadFactor    maxDemandOverLoadCounter    __typename  }}`  
  
    let headers={
      tenantCode: config.constants.BASE_TENANT_CODE
      }
      return  apolloClientService.ApolloClientgqlsUsage(APIquery,headers); 
  }